import React from 'react'
import Navbar from '../../components/Navbar'
import Hero from '../Hero'
import HeroImg from '../../assets/ServicesImg/TechnologyHero.jpg';
import BottomContent from '../../components/BottomContent';
import { Link } from 'react-router-dom';
import ScrollButton from "../../components/ScrollButton";
import Thank from '../../components/Thank';
import ContactButton from '../../components/ContactButton';
import DarkModeButton from '../../components/DarkModeButton';

// Import service images
import AgileImg from '../../assets/ServicesImg/Agile-Lifecycle.png';
import DevopsImg from '../../assets/ServicesImg/Dev-Ops.png';
import APIImg from '../../assets/ServicesImg/Api-Dev.png';
import IntelligentImg from '../../assets/ServicesImg/Intelligent-QA.png';
import ApplicationImg from '../../assets/ServicesImg/App-Dev.png';
import SupportImg from '../../assets/ServicesImg/It-Support.png';

export default function Technology() {
  const HeroTechnology = {
    heading: 'Technology & Engineering',
    subheading: 'Innovative Solutions for Modern Digital Challenges',
    des: `At Vedalytics, we deliver cutting-edge technology solutions to accelerate your digital transformation journey. From Agile lifecycle management and DevOps transformation to intelligent automation and application development, our technology expertise drives operational excellence and business agility.`,
    img: HeroImg
  }
  const technologyServices = [
    {
      image: AgileImg,
      heading: 'Agile Lifecycle & Lean Delivery',
      text: `Accelerate your development process with our Agile lifecycle and lean delivery practices. We help you implement Agile methodologies that foster collaboration, reduce lead times, and ensure continuous improvement. Our approach enhances efficiency and drives faster project deliveries.`,
      
    },
    {
      image: DevopsImg,
      heading: 'DevOps Transformation & Cloud Adoption',
      text: `Transform your IT operations with our DevOps practices, promoting automation, continuous integration, and delivery. We integrate cloud-native solutions and microservices architecture to enhance scalability and resilience, enabling seamless and agile software development.`,
      
    },
    {
      image: APIImg,
      heading: 'API Development & Data Services',
      text: `Build powerful, secure, and scalable APIs to enable seamless data exchange and integration. Our API development services enhance interoperability between systems, while our data practices ensure that your data is efficiently managed, processed, and analyzed for strategic insights.`,
      
    },
    {
      image:IntelligentImg ,
      heading: 'Intelligent Automation & QA Engineering',
      text: `Leverage the power of intelligent automation with RPA and CPA to optimize business processes. Our quality assurance and engineering services ensure high-performance applications, with rigorous testing and validation to maintain system integrity and reliability.`,
     
    },
    {
      image: ApplicationImg,
      heading: 'Application Development & Modern Technologies',
      text: `Stay ahead with modern application development using technologies like .NET, Java, Progressive Web Apps, Big Data, and GenAI. Our engineering team builds high-quality, robust applications to meet your evolving business needs.`,
   
    },
    {
      image: SupportImg,
      heading: 'Zero Maintenance & IT Support',
      text: `Leverage our Auto-Heal methodology to achieve zero maintenance, maintaining optimal application performance without manual effort. Our proactive IT support services detect and resolve issues ahead of time, ensuring uninterrupted business operations and maximum efficiency.`,
    }
  ];
  return (
    <>
      <Navbar />
      <Hero
        heading={HeroTechnology.heading}
        subheading={HeroTechnology.subheading}
        des={HeroTechnology.des}
        img={HeroImg}
      />
       <div className="container mt-5 mb-5">
        {technologyServices.map((technologyServices, index) => (
          <div className="row mb-5 align-items-center" key={index}>
              {/* Image */}
            <div className={`col-12 col-md-6 d-flex justify-content-center ${index % 2 === 0 ? "order-1 order-md-1" : "order-1 order-md-2"}`}>
              <img
                className="img-fluid"
                loading='lazy'
                src={technologyServices.image}
                alt={technologyServices.heading}
                style={{
                  maxWidth: "250px",
                  maxHeight: "250px",
                  width: "100%",
                  height: "auto",
                  borderRadius: "50px"
                }}
              />
            </div>

            {/* Text */}
                <div className={`col-12 col-md-6 text-center text-md-start ${index % 2 === 0 ? "order-2 order-md-2" : "order-2 order-md-1"}`}>
                  <h2 style={{ color: "var(--heading_color)",marginTop:'10px' }}>{technologyServices.heading}</h2>
                  <p className="fs-5 text-muted">{technologyServices.text}</p>
                </div>
          </div>
        ))}
      </div>
      {/* Call to Action Section - Improved */}
      <section className='' >
        <div className="p-5 text-center" style={{ backgroundColor: '#3BB893' }} data-aos="fade-up" data-aos-anchor-placement="top-center">
          <h3 className='text-light'>Having Projects ?</h3>
          <p className='text-light'>Schedule a Free Demo and Start Business you always Dream.</p>
          <div className="button">
            <button className='btn'><Link style={{ textDecoration: 'none', color: 'green' }} to='/scheduledemo'>Schedule Demo</Link></button>
          </div>
        </div>
      </section>
      <Thank />
      <ContactButton />
      <DarkModeButton />
      <BottomContent/>
      <ScrollButton/>
      {/* Custom CSS */}
      <style>{`
        .card {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border-radius: 12px;
          background: var(--card_color);
          color: var(--heading_color);
        }
        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }
      `}</style>
      
    </>
  )
}
